<template>
    <div>
      <h1>Hejsa, mit navn er Magnus og jeg er Holbæks bedste og mest betroede helhedsorienterede konsulent. Nedenfor finder du en liste over de personer jeg har hjulpet</h1>
      <!-- Her placerer du "Tidligere Arbejde"-sektionen -->
      <TidligereArbejde />
    </div>
  </template>
  
  <script>
  import TidligereArbejde from '../components/TidligereArbejde.vue';
  
  export default {
    name: 'HomePage',
    components: {
      TidligereArbejde,
    },
  };
  </script>
  
  <style scoped>
  /* Styles for forsiden */
  </style>